/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Popover from "@react/react-spectrum/Popover";
import { Flyout } from "components/quickTools/common/Flyout";
import SecondaryPanelCss from "./SecondaryPanel.css";
import { isNumber, isBoolean } from "utils/APIUtils";
import classNames from "classnames";

const SecondaryPanel = props => {
  const { panelConfig, flyoutConfig, closeFlyoutCallback, showFlyout, shouldUseMobileModernViewer } = props;
  const PanelComponent = panelConfig ? panelConfig.body : null;

  let flyoutComponent = null;
  let flyoutOffset = 0;
  let shouldAutoCloseFlyout = true;

  if (flyoutConfig) {
    flyoutComponent = flyoutConfig.body;
    flyoutOffset = isNumber(flyoutConfig.offset) ? flyoutConfig.offset : 0;
    shouldAutoCloseFlyout = isBoolean(flyoutConfig.shouldAutoCloseFlyout) ? flyoutConfig.shouldAutoCloseFlyout : true;
  }

  const offsetStyle = { top: `${flyoutOffset}px` };

  if (flyoutComponent) {
    showFlyout(true);
  }

  const separatorStyle = shouldUseMobileModernViewer
    ? [SecondaryPanelCss.separator, SecondaryPanelCss.mobileSeparator]
    : [SecondaryPanelCss.separator, SecondaryPanelCss.desktopSeparator];

  return (
    <Fragment>
      {PanelComponent ? (
        <Fragment>
          <div className={classNames(separatorStyle)} />
          <div className={SecondaryPanelCss.panel}>
            <PanelComponent />
            {flyoutComponent ? (
              <Popover isDialog={false} className={SecondaryPanelCss.flyoutPopover} style={offsetStyle}>
                <Flyout
                  component={flyoutComponent}
                  closeFlyout={() => {
                    showFlyout(false);
                    closeFlyoutCallback();
                  }}
                  shouldAutoCloseFlyout={shouldAutoCloseFlyout}
                />
              </Popover>
            ) : null}
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  );
};

SecondaryPanel.propTypes = {
  panelConfig: PropTypes.object,
  flyoutConfig: PropTypes.object,
  shouldUseMobileModernViewer: PropTypes.bool
};

SecondaryPanel.defaultProps = {
  panelConfig: null,
  flyoutConfig: null,
  shouldUseMobileModernViewer: false
};

export default SecondaryPanel;
